module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cardtabs/cardtabs.component.css
// module id = ./src/app/components/cardtabs/cardtabs.component.css
// module chunks = main